// extracted by mini-css-extract-plugin
module.exports = {"section":"BookingMainPage_section__ve8Kd","description":"BookingMainPage_description__1GDjZ"};